//Include Both Helper File with needed methods

import {
  getUserProfile,
  postFakeProfile,
  postJwtProfile,
} from "../../../helpers/backend_helper";

// action
import {
  profileSuccess,
  profileError,
  resetProfileFlagChange,
} from "./reducer";

export const fetchUserProfile = () => async (_dispatch: any) => {
  try {
    const response = await getUserProfile();
    console.log("[fetchUserProfile] response:", response);
    return { success: true, data: response };
  } catch (error: any) {
    console.error("[fetchUserProfile] error:", error);
    return { success: false, error: error?.message };
  }
};

export const editProfile = (user: any) => async (dispatch: any) => {
  try {
    let response;

    response = postJwtProfile({
      username: user.username,
      idx: user.idx,
    });

    const data = await response;

    if (data) {
      dispatch(profileSuccess(data));
    }
  } catch (error) {
    dispatch(profileError(error));
  }
};

export const resetProfileFlag = () => {
  try {
    const response = resetProfileFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};
